//#region common/enums.ts
let MenuType = /* @__PURE__ */ function(MenuType) {
	MenuType["DINE_IN"] = "DINE_IN";
	MenuType["PICK_UP"] = "PICK_UP";
	MenuType["DELIVERY"] = "DELIVERY";
	return MenuType;
}({});
let SectionType = /* @__PURE__ */ function(SectionType) {
	SectionType["STANDARD"] = "STANDARD";
	SectionType["FEATURED"] = "FEATURED";
	return SectionType;
}({});
let DiscountType = /* @__PURE__ */ function(DiscountType) {
	DiscountType["FLAT"] = "FLAT";
	DiscountType["PERCENTAGE"] = "PERCENTAGE";
	return DiscountType;
}({});
let DisplayType = /* @__PURE__ */ function(DisplayType) {
	DisplayType["EXPANDED"] = "EXPANDED";
	DisplayType["COLLAPSED"] = "COLLAPSED";
	return DisplayType;
}({});
let UserRole = /* @__PURE__ */ function(UserRole) {
	UserRole["ADMIN"] = "ADMIN";
	UserRole["CUSTOMER"] = "CUSTOMER";
	return UserRole;
}({});
let UserTenant = /* @__PURE__ */ function(UserTenant) {
	UserTenant["AITISAL"] = "AITISAL";
	UserTenant["RESTAURANT"] = "RESTAURANT";
	UserTenant["CUSTOMER"] = "CUSTOMER";
	return UserTenant;
}({});
let NestedItemType = /* @__PURE__ */ function(NestedItemType) {
	NestedItemType["PAIRED"] = "PAIRED";
	NestedItemType["BUNDLED"] = "BUNDLED";
	return NestedItemType;
}({});
let PointOfOrderGroupType = /* @__PURE__ */ function(PointOfOrderGroupType) {
	PointOfOrderGroupType["FLOOR"] = "FLOOR";
	PointOfOrderGroupType["SYSTEM"] = "SYSTEM";
	return PointOfOrderGroupType;
}({});
let PointOfOrderType = /* @__PURE__ */ function(PointOfOrderType) {
	PointOfOrderType["TABLE"] = "TABLE";
	PointOfOrderType["WEB"] = "WEB";
	PointOfOrderType["POS"] = "POS";
	return PointOfOrderType;
}({});
let OrderMode = /* @__PURE__ */ function(OrderMode) {
	OrderMode["SINGLE_USER_SINGLE_ORDER"] = "SINGLE_USER_SINGLE_ORDER";
	OrderMode["SINGLE_USER_MULTI_ORDER"] = "SINGLE_USER_MULTI_ORDER";
	OrderMode["MULTI_USER_SINGLE_ORDER"] = "MULTI_USER_SINGLE_ORDER";
	OrderMode["MULTI_USER_MULTI_ORDER"] = "MULTI_USER_MULTI_ORDER";
	return OrderMode;
}({});
let OrderStatus = /* @__PURE__ */ function(OrderStatus) {
	OrderStatus["NEW"] = "NEW";
	OrderStatus["ACCEPTED"] = "ACCEPTED";
	OrderStatus["CLOSED"] = "CLOSED";
	OrderStatus["CANCELLED"] = "CANCELLED";
	return OrderStatus;
}({});
let BranchType = /* @__PURE__ */ function(BranchType) {
	BranchType["RESTAURANT"] = "RESTAURANT";
	BranchType["RETAIL"] = "RETAIL";
	return BranchType;
}({});
const CurrencyCodes = { PKR: "PKR" };
const TimeZones = { "Asia/Karachi": "Asia/Karachi" };
let WeekDay = /* @__PURE__ */ function(WeekDay) {
	WeekDay["Monday"] = "Monday";
	WeekDay["Tuesday"] = "Tuesday";
	WeekDay["Wednesday"] = "Wednesday";
	WeekDay["Thursday"] = "Thursday";
	WeekDay["Friday"] = "Friday";
	WeekDay["Saturday"] = "Saturday";
	WeekDay["Sunday"] = "Sunday";
	return WeekDay;
}({});
let TaxType = /* @__PURE__ */ function(TaxType) {
	TaxType["FLAT"] = "FLAT";
	TaxType["PERCENT"] = "PERCENT";
	return TaxType;
}({});
let BackOrderStatus = /* @__PURE__ */ function(BackOrderStatus) {
	BackOrderStatus["ALLOWED"] = "ALLOWED";
	BackOrderStatus["NOT_ALLOWED"] = "NOT_ALLOWED";
	BackOrderStatus["ALLOWED_WITH_NOTIFICATION"] = "ALLOWED_WITH_NOTIFICATION";
	return BackOrderStatus;
}({});
const CountryCodes = { PK: "PK" };
const LanguageCodes = {
	en: "en",
	ur: "ur"
};
let Action = /* @__PURE__ */ function(Action) {
	Action["Manage"] = "manage";
	Action["Create"] = "create";
	Action["Read"] = "read";
	Action["Update"] = "update";
	Action["Delete"] = "delete";
	return Action;
}({});
let Subject = /* @__PURE__ */ function(Subject) {
	Subject["All"] = "all";
	Subject["Customer"] = "customer";
	Subject["Customization"] = "customization";
	Subject["Item"] = "item";
	Subject["Menu"] = "menu";
	Subject["Order"] = "order";
	Subject["OrderItem"] = "order-item";
	Subject["PointOfOrder"] = "point-of-order";
	Subject["QR"] = "qr";
	Subject["Restaurant"] = "restaurant";
	Subject["Section"] = "section";
	Subject["StockItem"] = "stock-item";
	Subject["SubOrder"] = "sub-order";
	Subject["POS"] = "pos";
	Subject["Report"] = "report";
	return Subject;
}({});
let FulfillmentMethod = /* @__PURE__ */ function(FulfillmentMethod) {
	FulfillmentMethod["BYKEA"] = "BYKEA";
	FulfillmentMethod["BRANCH_DELIVERY"] = "BRANCH_DELIVERY";
	FulfillmentMethod["TAKE_AWAY"] = "TAKE_AWAY";
	FulfillmentMethod["DINE_IN"] = "DINE_IN";
	FulfillmentMethod["PICK_UP"] = "PICK_UP";
	return FulfillmentMethod;
}({});
let LogisticsProvider = /* @__PURE__ */ function(LogisticsProvider) {
	LogisticsProvider["BYKEA"] = "BYKEA";
	return LogisticsProvider;
}({});
let LogisticsOrderStatus = /* @__PURE__ */ function(LogisticsOrderStatus) {
	LogisticsOrderStatus["CREATED"] = "created";
	LogisticsOrderStatus["CANCELLED"] = "cancelled";
	LogisticsOrderStatus["PENDING"] = "pending";
	LogisticsOrderStatus["ACCEPTED"] = "accepted";
	LogisticsOrderStatus["ARRIVED"] = "arrived";
	LogisticsOrderStatus["STARTED"] = "started";
	LogisticsOrderStatus["FINISHED"] = "finished";
	LogisticsOrderStatus["FEEDBACK"] = "feedback";
	return LogisticsOrderStatus;
}({});
let TickerType = /* @__PURE__ */ function(TickerType) {
	TickerType["INFO"] = "info";
	TickerType["WARNING"] = "warning";
	TickerType["SUCCESS"] = "success";
	TickerType["ANNOUNCEMENT"] = "announcement";
	return TickerType;
}({});

//#endregion
//#region common/payment-method.ts
let PaymentMethodType = /* @__PURE__ */ function(PaymentMethodType) {
	PaymentMethodType["CASH"] = "CASH";
	PaymentMethodType["CARD"] = "CARD";
	PaymentMethodType["ONLINE"] = "ONLINE";
	PaymentMethodType["BANK_TRANSFER"] = "BANK_TRANSFER";
	return PaymentMethodType;
}({});
let PaymentProvider = /* @__PURE__ */ function(PaymentProvider) {
	PaymentProvider["SAFEPAY"] = "SAFEPAY";
	return PaymentProvider;
}({});

//#endregion
//#region common/policy.ts
function permissionDocumentToPermissions(permissionDocument) {
	return permissionDocument.sections.flatMap((section) => section.subjectPermissions.map((permission) => ({
		subject: permission.subject,
		action: permission.actions.map((action) => action.allowed ? action.action : null).filter(Boolean)
	})));
}

//#endregion
//#region common/schedule.ts
/**
* Default schedule with all days active from 00:00 to 23:59
*/
const DEFAULT_SCHEDULE = [
	{
		dayOfWeek: WeekDay.Monday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	},
	{
		dayOfWeek: WeekDay.Tuesday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	},
	{
		dayOfWeek: WeekDay.Wednesday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	},
	{
		dayOfWeek: WeekDay.Thursday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	},
	{
		dayOfWeek: WeekDay.Friday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	},
	{
		dayOfWeek: WeekDay.Saturday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	},
	{
		dayOfWeek: WeekDay.Sunday,
		isActive: true,
		slots: [{
			startTime: "00:00",
			endTime: "23:59"
		}]
	}
];
/**
* Order of days in a week (for iteration purposes)
*/
const WEEK_DAYS_ORDER = [
	WeekDay.Monday,
	WeekDay.Tuesday,
	WeekDay.Wednesday,
	WeekDay.Thursday,
	WeekDay.Friday,
	WeekDay.Saturday,
	WeekDay.Sunday
];

//#endregion
//#region common/schedule-utils.ts
/**
* Parse time string (HH:mm) into minutes since midnight
*/
function timeToMinutes(time) {
	const [hours, minutes] = time.split(":").map(Number);
	return hours * 60 + minutes;
}
/**
* Convert minutes since midnight to time string (HH:mm)
*/
function minutesToTime(minutes) {
	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;
	return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
}
/**
* Get the next day of the week
*/
function getNextDay(day) {
	return WEEK_DAYS_ORDER[(WEEK_DAYS_ORDER.indexOf(day) + 1) % 7];
}
/**
* Check if a time slot crosses day boundary (endTime < startTime)
*/
function slotCrossesDayBoundary(slot) {
	return timeToMinutes(slot.endTime) < timeToMinutes(slot.startTime);
}
/**
* Split a slot that crosses day boundary into two slots
* Returns the remainder slot for the next day
*/
function splitDayCrossingSlot(slot) {
	return {
		currentDaySlot: {
			startTime: slot.startTime,
			endTime: "23:59"
		},
		nextDaySlot: {
			startTime: "00:00",
			endTime: slot.endTime
		}
	};
}
/**
* Check if a time (in minutes) falls within a time slot
*/
function isTimeInSlot(timeMinutes, slot) {
	const startMinutes = timeToMinutes(slot.startTime);
	const endMinutes = timeToMinutes(slot.endTime);
	return timeMinutes >= startMinutes && timeMinutes <= endMinutes;
}
/**
* Check if the current time falls within a schedule
* @param schedule The schedule to check against
* @param timezone The timezone to use (e.g., "Asia/Karachi")
* @param currentDate Optional date to check (defaults to now)
*/
function isWithinSchedule(schedule, timezone, currentDate) {
	if (!schedule || schedule.length === 0) return true;
	const now = currentDate || /* @__PURE__ */ new Date();
	let dayOfWeek;
	let currentTimeMinutes;
	try {
		const parts = new Intl.DateTimeFormat("en-US", {
			timeZone: timezone,
			weekday: "long",
			hour: "2-digit",
			minute: "2-digit",
			hour12: false
		}).formatToParts(now);
		dayOfWeek = parts.find((p) => p.type === "weekday")?.value || "";
		let hour = parts.find((p) => p.type === "hour")?.value || "00";
		const minute = parts.find((p) => p.type === "minute")?.value || "00";
		if (hour === "24") hour = "00";
		currentTimeMinutes = parseInt(hour) * 60 + parseInt(minute);
	} catch (error) {
		console.error("Invalid timezone:", timezone, error);
		return true;
	}
	const todaySchedule = schedule.find((s) => s.dayOfWeek === dayOfWeek);
	if (!todaySchedule) return false;
	if (!todaySchedule.isActive) return false;
	if (!todaySchedule.slots || !Array.isArray(todaySchedule.slots) || todaySchedule.slots.length === 0) return true;
	for (const slot of todaySchedule.slots) {
		if (!slot || !slot.startTime || !slot.endTime) continue;
		if (isTimeInSlot(currentTimeMinutes, slot)) return true;
	}
	return false;
}
/**
* Validate a schedule for correctness
*/
function validateSchedule(schedule) {
	const errors = [];
	for (const daySchedule of schedule) {
		if (!daySchedule.isActive) continue;
		for (let i = 0; i < daySchedule.slots.length; i++) {
			const slot = daySchedule.slots[i];
			const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
			if (!timeRegex.test(slot.startTime)) errors.push(`Invalid start time format for ${daySchedule.dayOfWeek} slot ${i + 1}`);
			if (!timeRegex.test(slot.endTime)) errors.push(`Invalid end time format for ${daySchedule.dayOfWeek} slot ${i + 1}`);
			for (let j = i + 1; j < daySchedule.slots.length; j++) {
				const otherSlot = daySchedule.slots[j];
				if (slotsOverlap(slot, otherSlot)) errors.push(`Overlapping slots on ${daySchedule.dayOfWeek}: slot ${i + 1} and slot ${j + 1}`);
			}
		}
	}
	return {
		valid: errors.length === 0,
		errors
	};
}
/**
* Check if two time slots overlap
*/
function slotsOverlap(slot1, slot2) {
	const start1 = timeToMinutes(slot1.startTime);
	const end1 = timeToMinutes(slot1.endTime);
	const start2 = timeToMinutes(slot2.startTime);
	return start1 <= timeToMinutes(slot2.endTime) && start2 <= end1;
}
/**
* Normalize a schedule by splitting any slots that cross day boundaries
*/
function normalizeSchedule(schedule) {
	const normalizedSchedule = [];
	for (const daySchedule of schedule) {
		const normalizedSlots = [];
		let nextDaySlots = [];
		for (const slot of daySchedule.slots) if (slotCrossesDayBoundary(slot)) {
			const { currentDaySlot, nextDaySlot } = splitDayCrossingSlot(slot);
			normalizedSlots.push(currentDaySlot);
			nextDaySlots.push(nextDaySlot);
		} else normalizedSlots.push(slot);
		normalizedSchedule.push({
			...daySchedule,
			slots: normalizedSlots
		});
		if (nextDaySlots.length > 0) {
			const nextDay = getNextDay(daySchedule.dayOfWeek);
			const existingNextDay = normalizedSchedule.find((s) => s.dayOfWeek === nextDay);
			if (existingNextDay) existingNextDay.slots = [...nextDaySlots, ...existingNextDay.slots];
			else normalizedSchedule.push({
				dayOfWeek: nextDay,
				isActive: true,
				slots: nextDaySlots
			});
		}
	}
	return normalizedSchedule;
}

//#endregion
export { Action, BackOrderStatus, BranchType, CountryCodes, CurrencyCodes, DEFAULT_SCHEDULE, DiscountType, DisplayType, FulfillmentMethod, LanguageCodes, LogisticsOrderStatus, LogisticsProvider, MenuType, NestedItemType, OrderMode, OrderStatus, PaymentMethodType, PaymentProvider, PointOfOrderGroupType, PointOfOrderType, SectionType, Subject, TaxType, TickerType, TimeZones, UserRole, UserTenant, WEEK_DAYS_ORDER, WeekDay, getNextDay, isTimeInSlot, isWithinSchedule, minutesToTime, normalizeSchedule, permissionDocumentToPermissions, slotCrossesDayBoundary, splitDayCrossingSlot, timeToMinutes, validateSchedule };
//# sourceMappingURL=index.mjs.map